import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50" data-testid="site-footer">
      <div className="container-rp py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-3">
            <div className="font-display text-2xl font-bold" style={{ color: "var(--rp-primary)" }}>RiskPedia</div>
            <span className="text-[11px] font-mono px-2 py-0.5 rounded-sm" style={{ background: "var(--rp-primary)", color: "#fff" }}>SG</span>
          </div>
          <p className="text-sm text-slate-600 mt-4 max-w-sm leading-relaxed">
            The Risk Encyclopedia for Singapore BFSI. MAS TRM, PDPA, CSA, MindForge — translated into operating playbooks for risk professionals.
          </p>
          <div className="mt-6 overline-muted">PDPA · Personal Data Protection Commission</div>
          <p className="text-xs text-slate-500 mt-2 leading-relaxed">
            Educational content only. Not legal, regulatory or investment advice. © RiskPedia Singapore.
          </p>
        </div>
        <div>
          <div className="overline-muted mb-4">Frameworks</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/frameworks/iso-31000">ISO 31000</Link></li>
            <li><Link to="/frameworks/mas-trm">MAS TRM</Link></li>
            <li><Link to="/frameworks/coso-erm">COSO ERM</Link></li>
            <li><Link to="/frameworks">All frameworks</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline-muted mb-4">Singapore</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/singapore/mas-trm">MAS TRM</Link></li>
            <li><Link to="/singapore/pdpa-2012">PDPA 2012</Link></li>
            <li><Link to="/singapore/cybersecurity-act">Cybersecurity Act</Link></li>
            <li><Link to="/singapore/mindforge">MindForge AI</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline-muted mb-4">Company</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/glossary">Glossary</Link></li>
            <li><Link to="/tools">Tools</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="container-rp py-6 flex flex-col md:flex-row items-center justify-between text-xs text-slate-500">
          <div>RiskPedia Singapore · A localized edition of riskpedia.co.in · Made in SG 🇸🇬</div>
          <div className="font-mono mt-2 md:mt-0">v1.0 · January 2026</div>
        </div>
      </div>
    </footer>
  );
}
